import type { ModuleManifest } from '@confluent/shared/modules';

export const FINANCE_MODULE_ID = 'finance';

export const financeManifest: ModuleManifest = {
  id: FINANCE_MODULE_ID,
  kind: 'industry',
  displayName: 'Finance',
  description: 'Trading, portfolios, strategies, market data, signals',
  icon: 'TrendingUp',
  navOrder: 10,
  status: 'active',
  policies: [
    'CanTrade',
    'CanViewPortfolio',
    'CanManageRisk',
    'CanManageStrategies',
    'CanViewResearch',
    'CanManageWatchlists',
    'CanRunIngestionJobs',
  ],
  nav: [
    {
      path: '/finance',
      label: 'Trading Dashboard',
      icon: 'LayoutDashboard',
      group: 'Finance',
      order: 5,
      policy: 'CanViewPortfolio',
    },
    {
      path: '/finance/trading',
      label: 'Trading',
      icon: 'ArrowLeftRight',
      group: 'Finance',
      order: 10,
      policy: 'CanTrade',
    },
    {
      // The strategy list; the Strategy Tester opens from its rows (owner 2026-10-19), so it has no entry of its own.
      // Readable by everyone who reads strategy results; managing strategies is gated inside the page.
      path: '/finance/strategies',
      label: 'Strategies',
      icon: 'Target',
      group: 'Finance',
      order: 20,
      policy: 'CanViewStrategyResults',
    },
    {
      path: '/finance/portfolios',
      label: 'Portfolios',
      icon: 'PieChart',
      group: 'Finance',
      order: 30,
      policy: 'CanViewPortfolio',
    },
    {
      path: '/finance/indicators',
      label: 'Indicators',
      icon: 'Activity',
      group: 'Finance',
      order: 35,
      policy: 'CanViewResearch',
    },
    {
      path: '/finance/watchlist',
      label: 'Watchlist',
      icon: 'Eye',
      group: 'Finance',
      order: 40,
      policy: 'CanViewResearch',
    },
    {
      path: '/finance/market-data/ingestion',
      label: 'Data Ingestion',
      icon: 'DatabaseZap',
      group: 'Finance',
      order: 45,
      policy: 'CanRunIngestionJobs',
    },
    {
      path: '/agents/ml-insights',
      label: 'ML Insights',
      icon: 'Brain',
      group: 'Finance',
      order: 50,
      policy: 'CanViewAgents',
    },
    {
      path: '/admin/risk',
      label: 'Risk',
      icon: 'ShieldAlert',
      group: 'Finance',
      order: 60,
      policy: 'RequireSuperadmin',
    },
  ],
  // `code`: strategy discovery asks the code workforce for generated dashboards.
  dependsOn: ['core', 'code'],
  departments: [
    { slug: 'research', displayName: 'Research', sortOrder: 10 },
    { slug: 'risk', displayName: 'Risk', sortOrder: 20 },
    { slug: 'execution', displayName: 'Execution', sortOrder: 30 },
    { slug: 'compliance', displayName: 'Compliance', sortOrder: 40 },
    { slug: 'orchestration', displayName: 'Orchestration', sortOrder: 50 },
    { slug: 'discretionary', displayName: 'Discretionary Technical Trading', sortOrder: 60 },
  ],
};
